/** An on/off switch drawn inside a settings row; the row is the button. */
export function Switch({ on, label }: { on: boolean; label: string }) {
  return <span className={`chats-switch${on ? ' chats-switch--on' : ''}`} role="switch" aria-checked={on} aria-label={label} />;
}
